import React from 'react';

//icons
import {BsGithub} from "react-icons/bs";
import {FaLinkedin} from "react-icons/fa";

const SosialMedia = () => {
    return (
        <div className="app__social">
            <div style={{cursor: 'pointer'}}>
                <a href='https://github.com/mahamedmahad'>
                    <BsGithub/>
                </a>
            </div>
            <div style={{cursor: 'pointer'}}>
                <a href="https://www.linkedin.com/in/mahamed-mahad-3b192519b/">
                    <FaLinkedin/>
                </a>
            </div>
        </div>
    )
}
export default SosialMedia;